// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_8g-0";